import { createSlice } from "@reduxjs/toolkit";
import { getPageMetaData } from "../ReduxActions/getPageDataAction";

const initialState = {
  data: null,
  loading: false,
  error: null
};

const WebsitePageData = createSlice({
  name: "WebsitePageData",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {

    builder
      .addCase(getPageMetaData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPageMetaData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getPageMetaData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load org data";
      });
  },
});

export default WebsitePageData.reducer;
